import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n\tdisplay: block;\n\tcolor: ", ";\n\tmargin-bottom: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n\tmargin-bottom: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\tborder: none;\n\tpadding: 0;\n\tmargin: 0;\n\tmin-width: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tmargin-bottom: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { Text, TextAppearance, TextColor } from '../text';
import { styled } from '../theme-provider';
export var FieldsetAppearance;

(function (FieldsetAppearance) {
  FieldsetAppearance[FieldsetAppearance["Default"] = 0] = "Default";
  FieldsetAppearance[FieldsetAppearance["Error"] = 1] = "Error";
})(FieldsetAppearance || (FieldsetAppearance = {}));

var StyledLegend = styled.legend.withConfig({
  displayName: "StyledLegend",
  componentId: "sc-tm1fru"
})(_templateObject(), function (props) {
  return props.errorShouldBeVisible ? props.theme.size.static200 : props.theme.size.static350;
});
var StyledFieldset = styled.fieldset.withConfig({
  displayName: "StyledFieldset",
  componentId: "sc-1k3lf"
})(_templateObject2());
var StyledWrapper = styled.div.withConfig({
  displayName: "StyledWrapper",
  componentId: "sc-qtafox"
})(_templateObject3(), function (props) {
  return props.theme.size.static350;
});
var StyledErrorText = styled.span.withConfig({
  displayName: "StyledErrorText",
  componentId: "sc-1ar763i"
})(_templateObject4(), function (props) {
  return props.theme.interaction.recipe360.default;
}, function (props) {
  return props.errorShouldBeVisible && props.theme.size.static350;
});

var wrap = function wrap(child) {
  return React.createElement(StyledWrapper, null, child);
};

export var Fieldset = function Fieldset(props) {
  var children = props.children,
      legend = props.legend,
      required = props.required,
      appearance = props.appearance,
      errorText = props.errorText;
  var errorShouldBeVisible = Boolean(appearance === FieldsetAppearance.Error && errorText);
  return React.createElement(StyledFieldset, {
    required: required
  }, legend && React.createElement(StyledLegend, {
    errorShouldBeVisible: errorShouldBeVisible
  }, React.createElement(Text, {
    appearance: TextAppearance.copy0200,
    bold: true,
    staticSize: true
  }, legend, required && '*')), React.createElement(StyledErrorText, {
    errorShouldBeVisible: errorShouldBeVisible,
    "aria-live": "assertive",
    "aria-relevant": "all"
  }, errorShouldBeVisible && React.createElement(Text, {
    appearance: TextAppearance.copy0100,
    color: TextColor.inherit,
    staticSize: true
  }, errorText)), React.Children.map(children, wrap));
};